import rootReducer from "./reducers/rootReducer";
import { configureStore } from "@reduxjs/toolkit";

// Rehydrate userData from localStorage
const loadState = () => {
  try {
    const userData = localStorage.getItem('userData');
    
    if (userData) {
      const parsedUserData = JSON.parse(userData);
      
      // Only return persisted state if userData exists and is valid
      if (parsedUserData && Object.keys(parsedUserData).length > 0) {
        return {
          auth: {
            userData: parsedUserData,
            isLoading: false,
            error: null,
            uniqueDeviceId: localStorage.getItem('uniqueDeviceId') || null
          }
        };
      }
    }
    
    return undefined; // Let reducers use their initial state
  } catch (error) {
    console.error('Error loading state from localStorage:', error);
    return undefined;
  }
};

const persistedState = loadState();

const store = configureStore({
    reducer: rootReducer,
    preloadedState: persistedState
});

export default store;